import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    margin: "0 0 0.5rem 0 !important",
  },
  summary: {
    margin: "0 !important",
    paddingTop: 0,
    paddingBottom: 0,
    backgroundColor: "#0154b0",
    color: "white",
  },
  header: {
    margin: 0,
  },
}));

export default useStyles;
